import { Typography } from '@mui/material';

const TitleComponent: React.FC<any> = ({ title }: any) => {
    return (
        <Typography variant="h5" component="div" m={2}>
            {title}
        </Typography>
    );
};

export default TitleComponent;
